import axios from "axios";
import { API_URL } from "../creds";


// ============================================
// AXIOS INSTANCE
// ============================================
const api = axios.create({
    baseURL: API_URL,
});


// ============================================
// ADD TOKEN IN EVERY REQUEST
// ============================================
api.interceptors.request.use(
    (config) => {

        const token = localStorage.getItem("access_token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);


// ============================================
// GET USERS
// ============================================
export const getUsers = () =>
    api.get("/users");


// ============================================
// CREATE USER
// ============================================
export const createUser = (data) =>
    api.post("/userAuthRegister", data);


// ============================================
// UPDATE USER
// ============================================
export const updateUser = (id, data) =>
    api.put(`/users/${id}`, data);


// ============================================
// CHANGE PASSWORD
// ============================================
export const changePassword = (id, password) =>
    api.put(`/users/${id}/password`, {
        password,
    });